// src/plugins/posthog.js
import posthog from 'posthog-js'
import constants from '../../constant' 

export default {
    install(Vue) {
        posthog.init(
            constants.posthogKey,
            {
                api_host: 'https://eu.i.posthog.com'
            }
        )

        // Vue.prototype.$posthog = posthog
        Vue.prototype.$posthog = {
            identifyUser(userId, userEmail) {
                posthog.identify(userId, { email: userEmail });
            },

            trackRoomJoined(eventId) {
                posthog.capture('Room Joined', { eventId: eventId });
            },

            trackCastJoined(eventId) {
                posthog.capture('Cast Joined', { eventId: eventId });
            },

            trackNftGatedPageView(eventId) {
                posthog.capture('Nft Gated Page View', { eventId: eventId });
            },

            trackNftGatedPurchase(eventId) {
                posthog.capture('Nft Gated Ticket Purchase', { eventId: eventId });
            },

            // trackEvent(eventName, properties = {}) {
            //     posthog.capture(eventName, properties);
            // },

            // trackUserSignup(userId, userEmail) {
            //     this.identifyUser(userId, userEmail);
            //     posthog.capture('User Signed Up', { userId, userEmail });
            // },

            // trackUserLogin(userId, userEmail) {
            //     this.identifyUser(userId, userEmail);
            //     posthog.capture('User Logged In', { userId, userEmail });
            // },

            // trackPageView(pageName) {
            //     posthog.capture('$pageview', { page: pageName });
            // },

            // trackFeatureUsage(featureName) {
            //     posthog.capture('Feature Used', { feature: featureName });
            // },

            // trackError(errorMessage) {
            //     posthog.capture('Error Occurred', { error: errorMessage });
            // },

            // trackCustomEvent(eventName, customProps = {}) {
            //     posthog.capture(eventName, customProps);
            // }
        }
    }
}